import React, { Component } from 'react';
import { connect } from "react-redux";
import "./style.scss";

// reactstrap imports
import { Col, Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';

// redux
import { login } from "../../actions/users.action";

class ConnectedConnexionContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userEmail: null,
      userPassword: null
    };

    this.goLogin = this.goLogin.bind(this);
  }

  goLogin() {
    const { userEmail, userPassword } = this.state;
    this.props.login(userEmail, userPassword);
  }

  render() {
    const { error } = this.props;

    return (
      <div>
        <Form>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Adresse mail</Label>
                <Input
                  className="input-text"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="votre adresse mail"
                  required
                  autoFocus
                  onChange={e => {
                    this.setState({ userEmail: e.target.value });
                    e.preventDefault();
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="examplePassword">Mot de passe</Label>
                <Input
                  className="input-text"
                  type="password"
                  name="password"
                  id="password"
                  placeholder="votre mot de passe"
                  required
                  autoFocus
                  onChange={e => {
                    this.setState({ userPassword: e.target.value });
                    e.preventDefault();
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <Button onClick={this.goLogin}>Connexion</Button>
            </Col>
          </Row>
        </Form>
        {error ? (
          <div>
            <p>
              {error.message}
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

const mstp = state => ({
  error: state.login.error
});

const mdtp = dispatch => ({
  login: (userEmail, userPassword) => dispatch(login(userEmail, userPassword))
});

const Connexion = connect(
  mstp,
  mdtp
)(ConnectedConnexionContent);

export default Connexion;